import React from "react";
import { motion } from "framer-motion";

const shimmer = {
  backgroundPosition: ["200% 0%", "-200% 0%"],
};

function SkeletonBlock({ height = 16, width = "100%", radius = 12 }) {
  return (
    <motion.div
      animate={shimmer}
      transition={{
        repeat: Infinity,
        duration: 1.8,
        ease: "linear",
      }}
      style={{
        height,
        width,
        borderRadius: radius,
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.10) 50%, rgba(255,255,255,0.04) 100%)",
        backgroundSize: "200% 100%",
      }}
    />
  );
}

function ToolResultSkeleton({ count = 3, isDark = true }) {
  return (
    <div
      style={{
        display: "grid",
        gap: "14px",
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: index * 0.08,
          }}
          style={{
            padding: "18px",
            borderRadius: "22px",
            border: isDark
              ? "1px solid rgba(148,163,184,0.10)"
              : "1px solid rgba(15,23,42,0.06)",
            background: isDark
              ? "rgba(15,23,42,0.72)"
              : "rgba(255,255,255,0.88)",
            backdropFilter: "blur(18px)",
            display: "grid",
            gap: "14px",
            overflow: "hidden",
          }}
        >
          <SkeletonBlock height={20} width="38%" />
          <SkeletonBlock height={14} width="100%" />
          <SkeletonBlock height={14} width="90%" />
          <SkeletonBlock height={14} width="82%" />

          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              marginTop: "8px",
            }}
          >
            <SkeletonBlock height={30} width={90} radius={999} />
            <SkeletonBlock height={30} width={110} radius={999} />
            <SkeletonBlock height={30} width={80} radius={999} />
          </div>

          <div
            style={{
              display: "grid",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <SkeletonBlock height={8} width="100%" radius={999} />
            <SkeletonBlock height={8} width="78%" radius={999} />
          </div>
        </motion.div>
      ))}
    </div>
  );
}

export default ToolResultSkeleton;
